import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/shared/lib/hooks";
import { selectIsAuthenticated } from "../../model/authSelectors";
import { AppRoutes } from "@/shared/config/routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={AppRoutes.LOGIN} replace />;
  }

  return <>{children}</>;
};
